import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { SearchInputComponent } from './search-input.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		FormsModule,
		GoMaterialModule
	],
	declarations: [
		SearchInputComponent
	],
	exports: [
		SearchInputComponent
	]
})
export class SearchInputModule {}
